<template>
  <div class="animated fadeIn" id="iframediv">
    <iframe width="100%" height="100%" :src="src" style="border-width: 0px;"></iframe>
  </div>
</template>

<script>
export default {
  name: "registropers",
  mixins: [window.myMixin],
  components: {},
  data: function() {
    return {};
  },
  computed: {
    src() {
      var p = "corsid=" + this.getCorsID() + "&schema=" + this.getSchema() + "&registro=true"
      if(window.ENAC)
        return "https://swone.cfpcanossa.it/AnteprimaVotiAlunni.php?param=" + btoa(p)
      else
        return "https://swone.ecfop.it/AnteprimaVotiAlunni.php?param=" + btoa(p)
    },
  },
  methods: {},
  mounted: function() {
    console.log("def");
    document.getElementById("iframediv").parentNode.classList.add("h100");
  }
};
</script>

<style>
div.h100 {
  height: calc(100% - 80px);
}
</style>
<style scoped>
div.animated {
  height: 100%;
}
</style>
